/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * Our pre-calculated trig data
 */
import { ITriangulateCalcData } from '@appCanvasCommon/fontpath/fontpath.interfaces';
import roboto from 'src/assets/fonts/Roboto-TrigData.json';
import robotoMedium from 'src/assets/fonts/Roboto-Medium-TrigData.json';
import robotoBlack from 'src/assets/fonts/Roboto-Black-TrigData.json';

export const FONT_TRIG_DATA = {
	ROBOTO: roboto as any as ITriangulateCalcData,
	ROBOTO_MEDIUM: robotoMedium as any as ITriangulateCalcData,
	ROBOTO_BLACK: robotoBlack as any as ITriangulateCalcData,
};
